export default __webpack_public_path__ + "assets/images/84e4d3fc36022247d54b8d40938bcc53.png";